/**
 * 信息流加载防抖函数
 * @param { Function } fn
 * @param { number } time
 */
const debounce = function debounce(fn, time = 300) {
    /* eslint-disable */
    const req = requestAnimationFrame || webkitRequestAnimationFrame;
    /* eslint-enable */
    let startTime = null;

    return function debounceFn(...argu) {
        const nowTime = +new Date();

        if (startTime !== null && nowTime - startTime >= time) {
            fn.apply(this, argu);
        } else {
            req(() => {
                fn.apply(this, argu);
            });
        }

        startTime = nowTime;
    };
};

export default debounce;
